import React, {useEffect, useMemo, useState} from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import classNames from "classnames";
import {navButtons} from "../../constants/copyright";
import {usePanel} from "../../redux/reducer/panel";
import Recommendations from "../recommendations/Recommendations";
import Tag from "../baseComponents/gui/tag/Tag";
import ReactPaginate from "react-paginate";
import Icon from "../baseComponents/gui/icon/Icon";
import PostCard from "../postCard/PostCard";
import {useRouter} from "next/router";
import Carousel from "../baseComponents/gui/carousel/Carousel";
import AuthorInfoButton from "./AuthorInfoButton";
import {settings} from "../../constants/carousel-settings";
import {createNewsDate} from "../../utils/data/createData";
import {safeHTML} from "../../utils/safeHTML";
import CurrentCirculations from "../currentCirculations/CurrentCirculations";
import styles from "./AuthorInfo.module.scss";

const AuthorInfo = React.forwardRef(
  function AuthorInfo(props, ref) {
    const router = useRouter();
    const {recommendation, author, tags, tabs, info, switchTab, setPage, description} = props;

    console.log(author);
    const {buttonBack, buttonToTop} = navButtons;
    const {filter, commentsInfo} = usePanel();  /// TODO: заменить на нужное!!!
    // const info = useMemo(() => commentsInfo, [commentsInfo]);   /// TODO: заменить на нужное!!!
    const {items} = info; /// TODO: тут должнен быть массив записей
    const itemsList = createNewsDate(items)
    const {pageCount, totalCount} = info['_meta'] /// TODO: заменить на нужное!!!
    const handlePageClick = (event) => {
      setPage(event.selected + 1);
      scrollTo({top: 0})
    }
    const [activeId, setActiveId] = useState(0);

    console.log(recommendation, 'RECOMMENDATION')

    useEffect(() => {
    }, [activeId]);
    //
    const newTabsList = useMemo(() => {
      let arr = tabs.map((item, index) => {
        return {
          id: index + 1,
          text: tabs[index].title,
          active: index + 1 === activeId,
          onClick: () => {
            setActiveId(index + 1);
            switchTab(tabs[index].href.slice(1))
          }
        }
      });
      return [
        {
          id: 0,
          text: "Все",
          active: 0 === activeId,
          onClick: () => {
            setActiveId(0)
            switchTab(false)
          }
        },
        ...arr];
    }, [tabs, activeId]);


    return (
      <section className={styles.authorInfo} ref={ref}>
        <div className={styles.authorInfo__content}>
          <Button {...buttonBack} routerUrl={filter === '/' ? filter : '/' + filter}
                  className={classNames("news__back", buttonStyles.button_back)}/>
          <div className={styles.authorInfo__header}>
            <div className={styles.authorInfo__photo}>
              <img src={author.photo} alt={author.slug} loading="lazy" width={96} height={96} />
            </div>
            <h2 className={styles.authorInfo__name}>{`${author.first_name} ${author.last_name}`}</h2>
            <div
              className={styles.authorInfo__description}>{safeHTML(description)}</div>
            <div className={styles.authorInfo__tags}>
              {tags?.map((el, id) => <Tag key={`tag-${id}`} {...el}/>)}
            </div>
            <CurrentCirculations list={author.bets}/>
          </div>

          <div className={styles.authorInfo__list}>
            <div className={styles.authorInfo__tab}>
              <Carousel item={AuthorInfoButton}
                        itemsData={newTabsList}
                        settings={{...settings.authorTabs}}
              />
            </div>

            <div className={styles.authorInfo__items}>
              {itemsList?.map((item, index) =>
                <PostCard
                  key={`item-${index}`}
                  {...item}
                  color={false}
                  tagsColor={true}
                  type={"author-info"}
                  author={false}
                  className={classNames(styles.authorInfo__item, styles.authorInfo__item_show)}
                  onClick={() => router.push(item.href)}
                />
              )}
            </div>

            <div className={styles.authorInfo__pagination}>
              {pageCount > 1 && <ReactPaginate
                breakLabel="..."
                nextLabel={
                  <Icon name={"nav-next"}/>
                }
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                containerClassName={styles.authorInfo__paginationList}
                pageClassName={styles.authorInfo__paginationItem}
                activeClassName={styles.authorInfo__paginationItem_active}
                previousClassName={classNames(styles.authorInfo__paginationButton, styles.authorInfo__paginationButton_prev)}
                nextClassName={classNames(styles.authorInfo__paginationButton, styles.authorInfo__paginationButton_next)}
                pageCount={pageCount}
                previousLabel={
                  <Icon name={"nav-prev"}/>
                }
                renderOnZeroPageCount={null}
              />}
            </div>
          </div>
          <Recommendations title={"Рекомендуем"} list={recommendation} mod={"quiz"} showAnimation={true}/>
          <Button {...buttonToTop}
                  className={classNames(
                    buttonStyles.button_white,
                    buttonStyles.button_border,
                    buttonStyles.button_icon,
                    buttonStyles.button_toTop,
                  )}
                  onClick={() => scrollTo({top: 0, behavior: "smooth"})}
          />

        </div>
      </section>
    );
  });
export default AuthorInfo;
AuthorInfo.propTypes = {};

